import React, { useEffect, useState } from "react";
import { useParams, useLocation, Link } from "react-router-dom";
import { CheckCircle2, Package, Copy, Download } from "lucide-react";
import { toast } from "sonner";
import api, { taka } from "@/lib/api";
import { downloadOrderInvoice } from "@/lib/invoice";
import { OrderTimeline } from "@/components/store/OrderTimeline";
import { STATUS_LABEL } from "@/lib/bd";

export default function OrderConfirmation() {
  const { orderNo } = useParams();
  const location = useLocation();
  const [order, setOrder] = useState(location.state?.order || null);

  useEffect(() => {
    if (!order) api.get(`/orders/track/${orderNo}`).then((r) => setOrder(r.data)).catch(() => {});
    window.scrollTo(0, 0);
  }, [orderNo]); // eslint-disable-line

  if (!order) return <div className="max-w-3xl mx-auto px-4 py-20 text-center text-stone-500">লোড হচ্ছে...</div>;

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
      <div className="bg-white rounded-2xl border border-stone-200 p-6 text-center">
        <CheckCircle2 size={56} className="mx-auto text-emerald-500 mb-3" />
        <h1 className="text-2xl font-bold text-[#1E3A2B]">অর্ডার সফল হয়েছে! 🎉</h1>
        <p className="text-stone-500 mt-1">আপনার অর্ডারটি গ্রহণ করা হয়েছে। শীঘ্রই যোগাযোগ করা হবে।</p>
        <div className="mt-4 inline-flex items-center gap-2 bg-emerald-50 text-emerald-800 font-bold px-4 py-2 rounded-xl" data-testid="order-no">
          {order.order_no}
          <button onClick={() => { navigator.clipboard.writeText(order.order_no); toast.success("কপি হয়েছে"); }}><Copy size={16} /></button>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
        <div className="bg-white rounded-2xl border border-stone-200 p-5">
          <h3 className="font-bold text-[#1E3A2B] mb-3 flex items-center gap-2"><Package size={18} /> অর্ডার ট্র্যাকিং</h3>
          <OrderTimeline status={order.status} />
        </div>
        <div className="bg-white rounded-2xl border border-stone-200 p-5">
          <h3 className="font-bold text-[#1E3A2B] mb-3">অর্ডার সারাংশ</h3>
          <div className="space-y-2 mb-3">
            {order.items.map((it, i) => (
              <div key={i} className="flex justify-between text-sm">
                <span className="text-stone-600">{it.name_bn} × {it.quantity}</span>
                <span className="font-medium">{taka(it.line_total)}</span>
              </div>
            ))}
          </div>
          <div className="border-t border-stone-200 pt-2 space-y-1 text-sm">
            <div className="flex justify-between"><span className="text-stone-600">সাবটোটাল</span><span>{taka(order.subtotal)}</span></div>
            <div className="flex justify-between"><span className="text-stone-600">ডেলিভারি</span><span>{taka(order.delivery_charge)}</span></div>
            {order.discount > 0 && <div className="flex justify-between text-emerald-700"><span>ছাড়</span><span>-{taka(order.discount)}</span></div>}
            <div className="flex justify-between font-bold text-[#1E3A2B] text-base pt-1"><span>সর্বমোট</span><span>{taka(order.total)}</span></div>
          </div>
          <div className="mt-3 text-sm text-stone-600 space-y-1">
            <div>পেমেন্ট: <span className="font-medium uppercase">{order.payment_method}</span></div>
            <div>অবস্থা: <span className="font-medium">{STATUS_LABEL[order.status]}</span></div>
          </div>
        </div>
      </div>

      <div className="mt-5 flex gap-3 justify-center flex-wrap">
        <button onClick={() => downloadOrderInvoice(order)} data-testid="download-invoice-btn" className="bg-[#CA8A04] text-white font-medium px-6 h-12 rounded-xl flex items-center gap-2"><Download size={18} /> ইনভয়েস ডাউনলোড</button>
        <Link to="/" className="bg-[#1E3A2B] text-white font-medium px-6 h-12 rounded-xl flex items-center">আরও কেনাকাটা</Link>
        <Link to={`/track?order=${order.order_no}`} className="border border-stone-300 bg-white font-medium px-6 h-12 rounded-xl flex items-center">অর্ডার ট্র্যাক</Link>
      </div>
    </div>
  );
}
